export default __webpack_public_path__ + "static/media/wall-clock-white-clockhands.901aa155.svg";